module.exports = __webpack_public_path__ + "static/media/detailIOT.2bf7fff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/fr/detailIOT.png
// module id = 87
// module chunks = 0